import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card/Card';
import Tabs from '../Tabs/Tabs';
import Container from '../Container';

export default function Navigation({
  identifier,
  track,
  doc: { authors = [] },
}) {
  const tabs = [
    {
      id: 'overview',
      label: 'Overview',
      to: `/${identifier}/`
    },
    {
      id: 'authors',
      label: `Authors (${authors.length})`,
      to: `/${identifier}/authors/`,
      rel: 'nofollow'
    }
  ];

  return (
    <div className="document-navigation" data-name="nav-tabs">
      <Card>
        <Container>
          <Tabs tabs={tabs} routed track={track} />
        </Container>
      </Card>
    </div>
  );
}

Navigation.propTypes = {
  identifier: PropTypes.string.isRequired,
  track: PropTypes.object.isRequired,
  doc: PropTypes.shape({
    authors: PropTypes.array
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/universal/ui/components/Document/Navigation.js